export class Screener {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    dateCreated: Date;
}